import React from 'react'

import FormItem from './FormItem'

class NewIncome extends React.Component {

  renderFormItems() {
    const { availableIncomes } = this.props;

    return Object.keys(availableIncomes).map((option) => (
      <FormItem
        key={ option }
        option={ option }
        title={ availableIncomes[option].title }
        type={ availableIncomes[option].type }
        iconName={ availableIncomes[option].icon_name }
        onClick={ this.props.onNewIncomeClick }
      />
    ))
  }

  render() {
    if (this.props.collapsed) {
      return(
        <div>
          <div
            className="card card-border card-btn card-add mt-3"
            id="dropdown-incomes-items"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            data-flip="false"
          >
            <div className='media mt-1 mb-1'>
              <div className='media-body'>
                Add additional source of income
              </div>
              <div className='align-self-center btn-icon'>
                <div className='material-icons'>add_circle_outline</div>
              </div>
            </div>
          </div>
          <div className="dropdown-menu" aria-labelledby="dropdown-incomes-items">
            { this.renderFormItems() }
          </div>
        </div>
      )
    } else {
      return(
        <div>
          { this.renderFormItems() }
        </div>
      )
    }
  }
}

export default NewIncome;
